import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=5f7e6f70&scoped=true&functional=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=5f7e6f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5f7e6f70",
  null
  
)

export default component.exports